module.exports = __webpack_public_path__ + "static/media/avatar-profile.9dcc1f7f.svg";